<template>
    <div class="mainpage2">
        <div class="whitebox2">
            <h1>{{email?email:''}} History</h1>
            <ul class="content" v-show="pagingConfig.list.length>0">
                <li v-for="(i, index) in pagingConfig.list" :key="index">
                    {{index+1}}.
                    <router-link :to="{path:`/result/${i.id}`}" >{{i.gender}}&nbsp;{{i.age}}&nbsp;Test Results on {{i.datetime | date}}</router-link></li>
            </ul>
            <h3 v-show="pagingConfig.list.length==0">Ooops! There are no test results yet!</h3>
            <kink-pagination v-show="pagingConfig.list.length>0" :paging-config="pagingConfig" style=""></kink-pagination>
        </div><!--whitebox end--->
    </div>
</template>

<script>
    import timestamp from 'time-stamp'
    import config from '../../config'
    export default {
        name: "manager-history",
        props:{
            email:{}
        },
        filters:{
            date(v){
                return timestamp('DD/MM/YYYY',new Date(v));
            }
        },
        data(){
            let pagingConfig={list:[],url:config.do_manager_history_url}
            if(this.email)
                pagingConfig.params = {email:this.email}
            return {
                pagingConfig
            }
        }
    }
</script>

<style scoped>
    .mainpage2 {
        width: 100%;
        float: left;
        height: 100%;
        min-height: 720px;
        padding-top:70px;
    }
    .mainpage2 .whitebox2 {
        background: #fff;
        width: 100%;
        max-width: 600px;
        border-radius: 5px;
        padding: 30px;
        margin: 60px auto;
    }
    .mainpage2 h1 {
        text-align: center;
        color: #b50102;
        line-height:43px;
    }
    .mainpage2 h3 {
        text-align: center;
        font-size: 18px;
        padding-top: 10px;
        font-weight: normal;
    }
    .mainpage2 .whitebox2 ul.content {
        list-style: none;
        width: 100%;
        font-size:14px;
        padding:10px 20px;
        border:1px solid #a0a0a0;
        border-radius:5px;
        margin:30px 0 20px 0;
    }
    .mainpage2 .whitebox2 ul.content li {
        width: 100%;
        padding: 12px 0;
    }
</style>